import { ReactNode } from "react";

interface PageHeaderProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
}

export function PageHeader({ icon, title, subtitle }: PageHeaderProps) {
  return (
    <div className="mb-2">
      <h1 className="text-2xl font-semibold flex items-center gap-2">
        {icon}
        {title}
      </h1>
      {subtitle && <p className="text-muted-foreground">{subtitle}</p>}
    </div>
  );
}
